<template>
    <div class="surface-0 border-round-xl p-3 shadow-1">
        <div class="flex justify-content-between align-items-start gap-3 mb-3 flex-wrap">
            <div class="flex flex-column gap-1">
                <span class="text-lg font-semibold">График значений</span>
                <span class="text-sm text-500">{{ subtitle }}</span>
            </div>
        </div>

        <div v-if="hasData" class="w-full" style="min-height: 320px;">
            <Chart type="line" :data="chartData" :options="chartOptions" class="w-full" />
        </div>
        <div v-else class="flex align-items-center justify-content-center text-sm text-500 border-1 border-dashed surface-border border-round-lg" style="min-height: 320px;">
            Нет данных для выбранного диапазона
        </div>
    </div>
</template>

<script>
export default {
    props: {
        chartData: {
            type: Object,
            default: () => ({ labels: [], datasets: [] })
        },
        rate: {
            type: Object,
            default: null
        }
    },
    computed: {
        hasData() {
            return !!(this.chartData && this.chartData.datasets && this.chartData.datasets[0] && this.chartData.datasets[0].data && this.chartData.datasets[0].data.length)
        },
        subtitle() {
            if (!this.rate) return 'Динамика курса за выбранный период'
            return `${(this.rate.from || '').toUpperCase()} / ${(this.rate.to || '').toUpperCase()} • ${this.rate.parse_type || 'source'}`
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true,
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            maxRotation: 0,
                            autoSkip: true,
                        }
                    },
                    y: {
                        beginAtZero: false,
                    }
                }
            }
        }
    }
}
</script>